/* eslint-disable import/prefer-default-export */
/* @flow */

import { type AxiosPromise } from 'axios';
import { type Account, type VerificationRequestData } from './api-iugu-types';
import xhr from './xhr';

export const getAccount = (): AxiosPromise<Account> => xhr.get('/iuguuuu/account');

export const requestVerification = (
    verificationRequestData: VerificationRequestData,
): AxiosPromise<void> => xhr.post('/iuguuuu/request-verification', verificationRequestData);
